import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import ExploreIcon from '@mui/icons-material/Explore';
import RoomIcon from '@mui/icons-material/Room';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function Hero() {
  const heroImageUrl = 'https://firebasestorage.googleapis.com/v0/b/landingmunigr.appspot.com/o/Turismo%2FDescubr%C3%AD%20La%20Granja%20(foto%20principal)-destacado.jpg?alt=media&token=66fc4331-d56e-4421-baa7-074602de296d';
  
  return (
    <Box
      className="hero"
      sx={{
        position: 'relative',
        height: { xs: '80vh', md: '90vh' },
        minHeight: { xs: 500, md: 600 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: { xs: 'center', md: 'flex-start' },
        color: 'common.white',
        mb: 6,
        overflow: 'hidden',
      }}
    >
      {/* Imagen de fondo */}
      <Box
        component="img"
        src={heroImageUrl}
        alt="La Granja"
        className="hero-bg"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: { xs: 'center top', md: '85% top' },
          zIndex: 0,
        }}
      />
      {/* Overlay para contraste */}
      <Box
        className="hero-overlay"
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 0,
          background:
            'linear-gradient(90deg, rgba(10,20,40,0.72) 0%, rgba(10,20,40,0.35) 40%, rgba(10,20,40,0.15) 100%)',
        }}
      />
      <Box sx={{ 
        zIndex: 1, 
        position: 'relative', 
        maxWidth: { xs: '100%', md: 450 }, 
        ml: { xs: 2, md: '150px' },
        mr: { xs: 2, md: 0 },
        textAlign: { xs: 'center', md: 'left' }
      }}>
        <Typography
          variant="h2"
          className="hero-title"
          sx={{ fontWeight: 800, mb: 3, fontSize: { xs: '2.2rem', md: '3.5rem' }, lineHeight: 1.2 }}
        >
          Descubrí La Granja
        </Typography>
        <Typography variant="h6" className="hero-subtitle" sx={{ mb: 4, opacity: 0.9, fontWeight: 400 }}>
        Descubre el encanto natural de la granja.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 4 }} className="hero-actions">
          <Button
            variant="contained"
            color="warning"
            size="large"
            startIcon={<ExploreIcon />}
            href="#descubri"
            className="hero-btn"
            sx={{ fontWeight: 700 }}
          >
            Explorar
          </Button>
          <Button
            variant="contained"
            color="success"
            size="large"
            startIcon={<RoomIcon />}
            href="#recorre"
            className="hero-btn"
            sx={{ fontWeight: 700 }}
          >
            Ver mapa
          </Button>
        </Stack>
      </Box>
      {/* Scroll icon */}
      <Box
        className="hero-scroll"
        sx={{
          position: 'absolute',
          bottom: { xs: 32, md: 60 },
          left: 0,
          right: 0,
          zIndex: 3,
          color: 'common.white',
          opacity: 0.8,
          cursor: 'pointer',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
        component="a"
        href="#search"
      >
        <KeyboardArrowDownIcon sx={{ fontSize: 48 }} />
      </Box>
    </Box>
  );
} 